export default "__VITE_ASSET__BWYHu6lh__"